const state = {
    tags:[]
}
const mutations = {
    updateTags(state,val){
        debugger
        this.state.tags.push(val);
    }
}
const actions = {

}

export default{
    namespaced: true,
    state,
    mutations,
    actions
}